import { getFocusStyle, IStyle, mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { getItemContentStyles } from '../CalendarSurfaceItemComponentRenderer';
import { IsFocusVisibleClassName } from '@uifabric/utilities';
import {
    CalendarSurfaceItemStyleProps,
    CalendarSurfaceItemStyles,
} from './CalendarSurfaceItem.types';

export const getStyles = (props: CalendarSurfaceItemStyleProps): CalendarSurfaceItemStyles => {
    const { freeBusyType, colorScheme, responseType, isCancelled, useBoldTheme } = props;

    return {
        root: computeRootStyles(props),
        content: getItemContentStyles(
            freeBusyType,
            responseType,
            colorScheme,
            isCancelled,
            useBoldTheme
        ),
    };
};

export const getAllDayStyles = (
    props: CalendarSurfaceItemStyleProps
): CalendarSurfaceItemStyles => {
    const {
        freeBusyType,
        colorScheme,
        responseType,
        hideBorder,
        isCancelled,
        useBoldTheme,
    } = props;

    return {
        root: computeRootStyles(props),
        content: [
            mergeStyles(
                getItemContentStyles(
                    freeBusyType,
                    responseType,
                    colorScheme,
                    isCancelled,
                    useBoldTheme
                )
            ),
            hideBorder &&
                responseType != 'NoResponseReceived' && {
                    selectors: {
                        '&::after': {
                            borderColor: 'transparent',
                        },
                    },
                },
        ],
    };
};

function computeRootStyles(props: CalendarSurfaceItemStyleProps): IStyle {
    const { className, theme, useBoldTheme } = props;

    return [
        mergeStyles(
            className,
            theme
                ? getFocusStyle(
                      theme,
                      0,
                      'absolute',
                      undefined /*high contrast style*/,
                      useBoldTheme ? theme.palette.white : 'transparent' /*border color*/
                  )
                : undefined,
            {
                width: '100%',
                selectors: {
                    '.addFocusOutline &:focus': {
                        outline: 'transparent !important', // Override .addFocusOutline !important
                        padding: useBoldTheme ? '2px 2px 2px 6px' : '',
                        selectors: {
                            // chrome doesn't like having items without a border-radius sitting exactly on top of things with it, so at specific zoom settings
                            // it looks like the free busy bar sits "just outside" the focus outline. Need to adjust it inwards during focus by 1px to prevent
                            [`.${IsFocusVisibleClassName} &:focus:not(:active) > div:first-child`]: {
                                top: 1,
                                bottom: 1,
                                border: 'none',
                            },
                            [`.${IsFocusVisibleClassName} html[dir=ltr] &:focus:not(:active) > div:first-child`]: {
                                left: 1,
                            },
                            [`.${IsFocusVisibleClassName} html[dir=rtl] &:focus:not(:active) > div:first-child`]: {
                                right: 1,
                            },
                            [`.${IsFocusVisibleClassName} &:focus:after`]: {
                                left: 0,
                                zIndex: 3, //override default z-index of 1 so that the outline shows above the free busy bar
                            },
                        },
                    },
                },
            }
        ),
    ];
}
